import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { GoalStrategiesDetailsContainer } from './GoalStrategiesDetailsContainer';

export const ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsContent = () => {
  const { resource } = useMetaLayoutContext();
  return (
    resource.withRelationship(fr.relationships.proposalScenarioGoalStrategyDetails.name,
      (rel) => <GoalStrategiesDetailsContainer relationship={rel} />,
      () => null)
  );
};
